export default "__VITE_ASSET__7aff497a__"